import {GoogleMap} from '@react-google-maps/api'
import type {JSX} from 'react'
import React, {useMemo} from 'react'

interface MapProps {
	defaultLng: number
	defaultLat: number
	initialZoom: number
	minZoom: number
	maxZoom?: number
	onLoad: (mapInstance: google.maps.Map | null) => void
	onClick?: () => void
	containerStyle?: React.CSSProperties
	containerClassName?: string
	children?: React.ReactNode
}
export const Map = ({
	defaultLng,
	defaultLat,
	initialZoom,
	minZoom,
	maxZoom = 0,
	onLoad,
	onClick,
	containerStyle,
	containerClassName,
	children,
}: MapProps): JSX.Element => {
	const center = useMemo(
		() => ({
			lat: defaultLat,
			lng: defaultLng,
		}),
		[defaultLat, defaultLng]
	)
	const zoom = useMemo(() => initialZoom, [initialZoom])

	return (
		<GoogleMap
			center={center}
			mapContainerClassName={containerClassName}
			mapContainerStyle={containerStyle}
			onClick={onClick}
			onLoad={onLoad}
			options={{
				disableDefaultUI: true,
				maxZoom,
				minZoom,
				zoomControl: true,
			}}
			zoom={zoom}
		>
			{children}
		</GoogleMap>
	)
}
